export enum EAuthStep {
  authenticationByPhone = "authenticationByPhone",
  authenticationByEmail = "authenticationByEmail",
  authenticationByApp = "authenticationByApp",
  authenticationByOther = "authenticationByOther",

  loginByEmail = "loginByEmail",
  loginByPhonePassword = "loginByPhonePassword",
  loginByPhoneOTP = "loginByPhoneOTP",
  recoveryByOTP = "recoveryByOTP",
  recoveryByEmailOTP = "recoveryByEmailOTP",

  setPasswordPhone = "setPasswordPhone",
  setPasswordEmail = "setPasswordEmail",
  setPassword = "setPassword",

  registration = "registration",
  registrationSetPassword = "registrationSetPassword",
  confirmRegistrationByEmail = "confirmRegistrationByEmail",
  confirmEmailByOTP = "confirmEmailByOTP",
  registrationByEmail = "registrationByEmail",

  recoveryByLogin = "recoveryByLogin",
  recoveryByEmail = "recoveryByEmail",

  fallbackLogin = "fallbackLogin",
}

export enum EFormDataFields {
  email = "email",
  phone = "phone",
  password = "pwd",
  code = "code",
  otpin = "otpin",
  regPassword = "regPwd",
  regPasswordRepeat = "regPwdRepeat",
  country = "country",
  otpID = "otpID",
  retryAfter = "retryAfter",
  mailSubscriptionsAllowed = "mailSubscriptionsAllowed",
  newPassword = "newPwd",
  newPasswordRepeat = "newPwdRepeat",
}

export enum EFallbackLoginStep {
  init = "init",
  confirm = "confirm",
}

export type IFormData = Partial<{
  [key in EFormDataFields]: key extends EFormDataFields.mailSubscriptionsAllowed
    ? boolean
    : string;
}>;
